import { GetUserRoles } from './GetUserRoles';

export const queries = {
  GetUserRoles,
};
